export default "__VITE_PUBLIC_ASSET__60c24ef9__"